<template>
  <div v-if="showValidation" class="seo-validation">
    <div class="seo-validation__header">
      <h3>SEO Content Warnings</h3>
      <p>Some of your SEO content doesn't meet the recommended requirements:</p>
    </div>
    
    <ul class="seo-validation__list">
      <li v-for="warning in getWarnings" :key="warning.field" class="seo-validation__item">
        <strong>{{ warning.field }}</strong>
        <template v-if="warning.length">
          ({{ warning.length }} chars):
        </template>
        <template v-if="warning.url">
          <br>
          <span class="url">URL: {{ warning.url }}</span>
        </template>
        <br>
        {{ warning.message }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useSeoValidation } from '@/composables/useSeoValidation'
import { computed } from 'vue'

const props = defineProps({
  content: {
    type: Object,
    required: true
  }
})

const { hasWarnings, getWarnings } = useSeoValidation(props.content)

// Only show in development
const showValidation = computed(() => {
  return import.meta.env.DEV && hasWarnings.value
})
</script>

<style lang="scss" scoped>
.seo-validation {
  
  width: 100%;
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  padding: 2%;
  color: #856404;
  z-index: 1000;

  &__header {
    margin-bottom: 1rem;
    
    h3 {
      margin: 0 0 0.5rem 0;
      font-size: 1.1rem;
    }
    
    p {
      margin: 0;
    }
  }

  &__list {
    margin: 0;
    padding-left: 1.5rem;
  }

  &__item {
    margin-bottom: 0.5rem;
    
    &:last-child {
      margin-bottom: 0;
    }

    .url {
      font-family: monospace;
      font-size: 0.9em;
      color: #666;
    }
  }
}
</style> 